import { createStore, RequestStatus } from "common-frontend-components";
import { useMemo } from "react";
const getDefaultNewSitePhoto = () => ({
    path: '',
    params: undefined,
    groups: [],
    files: [],
});
const { get, set, useStore, fetchStore } = createStore({
    getDefaultValues: () => ({
        data: [],
        status: RequestStatus.pending,
        pageIndex: 0,
        rowsPerPage: 9,
        newSitePhoto: getDefaultNewSitePhoto(),
    })
});
const getPageIndex = () => get().pageIndex;
const getRowsPerPage = () => get().rowsPerPage;
const setPageIndex = (pageIndex) => set({ pageIndex });
const setRowsPerPage = (rowsPerPage) => set({ rowsPerPage });
const handleChangePage = (_event, newPage) => { setPageIndex(newPage); };
const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageIndex(0);
};
const getPageItems = () => {
    const rowsPerPage = getRowsPerPage();
    const skip = getPageIndex() * rowsPerPage;
    return get().data.slice(skip, skip + rowsPerPage);
};
const usePageIndex = () => useStore(fetchStore.pageIndex);
const useRowsPerPage = () => useStore(fetchStore.rowsPerPage);
const usePageItems = () => {
    const data = useStore(fetchStore.data);
    const pageIndex = usePageIndex();
    const rowsPerPage = useRowsPerPage();
    return useMemo(() => getPageItems(), [data, pageIndex, rowsPerPage]);
};
export const sitePhotoStore = {
    clearSitePhoto: () => set({ newSitePhoto: getDefaultNewSitePhoto() }),
    getNewSitePhoto: () => get().newSitePhoto,
    setNewSitePhoto: (newSitePhoto) => set({ newSitePhoto }),
    // setNewSitePhotoLinks: (links:SitePhotoResponse['links']) => set(s => ({newSitePhoto: {...s.newSitePhoto, links}})),
    setNewSitePhotoFiles: (files) => set(s => ({ newSitePhoto: { ...s.newSitePhoto, files } })),
    // useNewSitePhotoLinks: () => useStore(s => s.newSitePhoto.links),
    useNewSitePhotoGroups: () => useStore(s => s.newSitePhoto.groups),
    useNewSitePhotoParams: () => useStore(s => s.newSitePhoto.params),
    // useNewSitePhotoPreviewImg: () => useStore(s => s.newSitePhoto.preview),
    onParamsChange: (params) => set(s => ({ newSitePhoto: { ...s.newSitePhoto, params } })),
    useNewSitePhotoPath: () => useStore(s => s.newSitePhoto.path),
    handleNewSitePhotoPathChange: (e) => set(s => ({ newSitePhoto: { ...s.newSitePhoto, path: e.target.value } })),
    useNewSitePhotoFile: () => useStore(s => s.newSitePhoto.files),
    getData: () => get().data,
    setData: (data) => set({ data }),
    useData: () => useStore(fetchStore.data),
    getStatus: () => get().status,
    setStatus: (status) => set({ status }),
    useStatus: () => useStore(fetchStore.status),
    getPageIndex,
    getRowsPerPage,
    setPageIndex,
    setRowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    getPageItems,
    usePageIndex,
    useRowsPerPage,
    usePageItems,
};
//# sourceMappingURL=sitePhotoStore.js.map